// Organization roles from auth.profile.org_roles
export const hasRole = (role, orgUuid, profile) => {
  if (!role || !orgUuid || !profile || Object.keys(profile.org_roles).length === 0
  ) {
    return false
  }

  if (role === 'all_admin') {
    return true
  }

  return profile.org_roles[orgUuid]?.includes(role)
}

export const hasAnyRole = (roles, orgUuid, profile) => {
  return roles?.some(role => hasRole(role, orgUuid, profile)) || false
}

export const hasProfileEntitlement = (entitlement, profile) => {
  return profile?.entitlements?.includes(entitlement) || false
}

export const hasAnyProfileEntitlement = (entitlements, profile) => {
  return entitlements?.some(entitlement => hasProfileEntitlement(entitlement, profile))
}

export const dtmRoles = [
  'mandiant_dtm_admin',
  'mandiant_dtm_user',
  'customer_dtm_admin',
  'customer_dtm_user'
]

export const maAdmins = ['approver', 'mandiant_admin', 'mandiant_approver', 'super_user', 'mandiant_promo_intel_admin']

export const orgAdmins = ['customer_dtm_admin', 'customer_eod_approver', 'customer_org_admin', 'org_admin']

export const maRolesMap = {
  approver: 'approver',
  mandiantAdmin: 'mandiant_admin',
  mandiantApprover: 'mandiant_approver',
  orgAdmin: 'org_admin',
  superUser: 'super_user',
  promotedReports: 'mandiant_promo_intel_admin'
}

export const orgAdminRoles = {
  customerDtmAdmin: 'customer_dtm_admin',
  customerEodApprover: 'customer_eod_approver',
  customerAdmin: 'customer_org_admin',
  orgAdmin: 'org_admin'
}

export const hasDTMRoles = (orgUuid, profile) => {
  return hasAnyRole(dtmRoles, orgUuid, profile) || hasAnyProfileEntitlement(dtmRoles, profile)
}

// User has any org or MA admin role
export const hasAnyAdminRole = (orgUuid, profile) => {
  if (!orgUuid || !profile) {
    return false
  }
  const hasOrgAdmin = orgAdmins.some(role => hasRole(role, orgUuid, profile))
  const hasMaAdmin = maAdmins.some(role => hasMaAdminRole(role, profile))
  return hasOrgAdmin || hasMaAdmin
}

// User has any MA specific admin role from profile.entitlements
export const hasAnyMaAdminRole = (profile) => {
  if (!profile || !profile || profile.entitlements.length === 0) {
    return false
  }
  return maAdmins.some(role => hasMaAdminRole(role, profile))
}

// User has any org admin role
export const hasOrgAdminRole = (orgUuid, profile) => {
  if (!orgUuid || !profile || !profile.org_roles || profile.org_roles.length === 0) {
    return false
  }
  return orgAdmins.some(role => hasRole(role, orgUuid, profile))
}

// User has a specific MA role
export const hasMaAdminRole = (role, profile) => {
  if (!role || !profile || profile.entitlements.length === 0) {
    return false
  }
  if (role === 'all_admin') {
    return true
  }
  return profile.entitlements.includes(role)
}

export const hasOrgRoles = (roles, orgUuid, profile) => {
  if (!roles) return false
  return roles.some(role => hasRole(role, orgUuid, profile))
}

export const hasMaAdminRoles = (roles, profile) => {
  if (!roles || !profile) {
    return false
  }
  return roles.some(role => hasMaAdminRole(role, profile))
}
